import { useMemo } from "react";
import { getUserFullName } from "@/core/utils/name";
import { useGetBusinessUsers } from "@/user/query";

/** Build employee choices for the account picker. */
export const useRosterUsers = (businessId: string) => {
  const query = useGetBusinessUsers(businessId);
  const userOptions = useMemo(
    () =>
      (query.isError ? [] : (query.data ?? [])).map((user) => ({
        value: user.id,
        label:
          getUserFullName(user) === "-" ? user.email : getUserFullName(user),
      })),
    [query.data, query.isError],
  );
  const userNames = useMemo(
    () => new Map(userOptions.map(({ value, label }) => [value, label])),
    [userOptions],
  );
  return { query, userOptions, userNames };
};
